import { createAsyncThunk } from '@reduxjs/toolkit'

import { RootState } from '../../app/store'
import { fetchData, postData } from '../../shared/api/api'
import {
  DashSceneResponse,
  FetchSceneByIdRequest,
  FetchSceneByIdSceneResponse,
} from './types'
import {
  setDossierDiscoveredIds,
  setDossierProgress,
} from '../dossier/dossierSlice'
import { fetchNearbyPOIsAndMap } from '../poi/poiThunks'

export const fetchSceneById = createAsyncThunk<
  FetchSceneByIdSceneResponse,
  FetchSceneByIdRequest,
  { state: RootState }
>('scene/fetchSceneById', async (sceneId, thunkAPI) => {
  const state = thunkAPI.getState()
  const { zone, user } = state
  const zoneId = zone?.data?.id

  if (!zoneId) {
    return thunkAPI.rejectWithValue(
      'Unable to fetch SceneById. Missing zoneId from state.'
    )
  }

  const body = {
    userId: user?.profile?.uid,
  }

  try {
    const response = await postData<FetchSceneByIdSceneResponse>(
      `/zones/${zoneId}/scenes/${sceneId}`,
      body
    )
    // Check for dossierProgression in response
    if (response?.dossierProgression)
      thunkAPI.dispatch(setDossierProgress({ ...response.dossierProgression }))
    // Update discoveredIds
    if (response?.discoveredIds)
      thunkAPI.dispatch(setDossierDiscoveredIds(response.discoveredIds))
    // If this was the first time visiting this POI, refetch nearby POIs and map
    if (response?.firstVisit) {
      const coords = state?.userLocation?.coords
      if (coords) {
        console.log('II')

        thunkAPI.dispatch(fetchNearbyPOIsAndMap(coords))
      } else {
        console.warn(
          '⚠️ First visit detected, but cannot refresh nearby POIs — missing coordinates from state.'
        )
      }
    }
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})

export const fetchDashScene = createAsyncThunk<
  DashSceneResponse,
  void,
  { state: RootState }
>('scene/fetchDashScene', async (_, thunkAPI) => {
  const state = thunkAPI.getState()
  const { zone, user } = state

  const userId = user?.profile?.uid
  const zoneId = zone?.data?.id

  if (!userId || !zoneId) {
    return thunkAPI.rejectWithValue('Missing userId,  or zoneId in state.')
  }

  try {
    const response = await fetchData<DashSceneResponse>(
      `/users/${userId}/dossiers/${zoneId}/dashboard`
    )
    // Dispatch updates if returned
    if (response?.dossierProgression)
      thunkAPI.dispatch(setDossierProgress(response.dossierProgression))

    if (response?.updatedDiscoveredIds)
      thunkAPI.dispatch(setDossierDiscoveredIds(response.updatedDiscoveredIds))

    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})
